import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { PublicyExposedPersonRoutingModule } from './publicy-exposed-person-routing.module';
import { MatRadioModule } from '@angular/material/radio';
import { PublicyExposedPersonComponent } from './publicy-exposed-person.component';
import { MatInputModule } from '@angular/material/input';
import { PublicExposedPersonDialogComponent } from '../dialogs/public-exposed-person-dialog/public-exposed-person-dialog.component';
import { MatDialogModule } from '@angular/material/dialog';
import { FiscalOfficerComponent } from '../dialogs/fiscal-officer/fiscal-officer.component';

@NgModule({
  declarations: [
    PublicyExposedPersonComponent,
    PublicExposedPersonDialogComponent,
    FiscalOfficerComponent
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    PublicyExposedPersonRoutingModule,
    MatInputModule,
    MatRadioModule,
    MatDialogModule
  ]
})
export class PublicyExposedPersonModule {}
